/* eslint-disable react/no-unescaped-entities */
import { useInView } from "react-intersection-observer";
import CountUp from "react-countup";
import pimg from "../../assets/dhruvtara/plus.jpg";
import AcInImg from "../../assets/dhruvtara/ac_in.webp";

export default function Plus() {
  const [ref1, inView1] = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  const [ref2, inView2] = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  const [ref3, inView3] = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  return (
    <>
      <section className="text-center lg:text-left lg:pt-20 lg:pb-12 ">
        <div className=" lg:text-center text-justify xl:px-32 ">
          <div className="grid items-center lg:grid-cols-2 ">
            <div className="">
              <div className="relative z-[1] block lg:rounded-lg bg-[hsla(0,0%,100%,0.55)] px-4 pb-4 pt-8 lg:px-6 lg:py-12 dark:bg-theme_2 dark:shadow-black/20 md:px-12 lg:-mr-14 backdrop-blur-[30px] shadow-lg">
                <img
                  src={AcInImg}
                  alt="session & collaborations"
                  className="w-[90%] text-center"
                />
                <p className="mb-12 text-neutral-500 text-sm lg:text-[18px] text-left">
                  <span className="block pb-1 font-bold text-slate-700">
                    Weekly Learning Drives
                  </span>
                  <p>
                    Organizes on-ground drives where volunteers taught basics of
                    Math, Science, and English through games and interactive
                    methods.
                  </p>
                  <span className="block pt-4 pb-1 font-bold text-slate-700">
                    Creative Development Workshops
                  </span>
                  <p>
                    Special drives focused on art, storytelling, music, and
                    dance to foster creativity and emotional expression among
                    children.
                  </p>
                  <span className="block pt-4 pb-1 font-bold text-slate-700">
                    Volunteer Engagement
                  </span>
                  <p>
                    Built a strong team of committed volunteers, onboarding them
                    through regular training sessions in child psychology,
                    communication, and curriculum delivery.
                  </p>
                  <span className="block pt-4 pb-1 font-bold text-slate-700">
                    Community Outreach Drives
                  </span>
                  <p>
                    Conducted donation drives for school supplies, clothes,
                    hygiene kits, and food in collaboration with local
                    communities and student groups.
                  </p>
                </p>

                <div className="grid gap-x-6 md:grid-cols-3 text-center">
                  <div className="mb-12 md:mb-0">
                    <div
                      ref={ref1}
                      className="text-theme_4 mb-2 text-3xl font-bold text-[#4CC5E1]"
                    >
                      {inView1 && <CountUp end={250} duration={2} />}+
                    </div>
                    <h5 className="mb-0 text-lg font-semibold text-[#00385B]">
                      Children Accross Delhi neighborhoods
                    </h5>
                  </div>

                  <div className="mb-12 md:mb-0">
                    <div
                      ref={ref2}
                      className="text-theme_4 mb-2 text-3xl font-bold text-[#4CC5E1]"
                    >
                      {inView2 && <CountUp end={10} duration={2} />}+
                    </div>
                    <h5 className="mb-0 text-lg font-semibold text-[#00385B]">
                      Education & Resource Drives
                    </h5>
                  </div>

                  <div className="mb-12 md:mb-0">
                    <div
                      ref={ref3}
                      className="text-theme_4 mb-2 text-3xl font-bold text-[#4CC5E1]"
                    >
                      {inView3 && <CountUp end={30} duration={2} />}+
                    </div>
                    <h5 className="mb-0 text-lg font-semibold text-[#00385B]">
                      Students from different colleges
                    </h5>
                  </div>
                </div>
                <br />
              </div>
            </div>

            <div>
              <img
                src={pimg}
                className="hidden lg:block w-[30rem] shadow-lg dark:shadow-black/20"
                alt=""
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
